import actionCreatorFactory from 'typescript-fsa'
import {
  CreateAboTopicRequest,
  DeleteAboTopicRequest, GetAboTopicHasPostingsRequest,
  UpdateAboTopicRequest,
} from '@3m5/sm_publish-frontend-api/apis/AboTopicsApi'
import {
  AboSettingsAuditLog,
  AboTopicHasPostingsResponse,
  MediaFileMetadata,
  TopicsWithMetadataResponse,
  UserAboSettings,
} from '@3m5/sm_publish-frontend-api/models'
import { AcknowledgeSettingsForNetworkPageRequest, GetAuditLogForNetworkPageRequest,
  UpdateAboSettingsForCurrentUserRequest,
} from '@3m5/sm_publish-frontend-api/apis/AboSettingsApi'
import { UploadTemporaryMediaFileRequest, UpdateCorePageSettingsRequest } from '@3m5/sm_publish-frontend-api'

const actionCreator = actionCreatorFactory('TOPIC')

/*
 * Actions
 */
export const createAboTopicInitiated = actionCreator<CreateAboTopicRequest>('CREATE_ABO_TOPIC_INITIATED')
export const createAboTopic = actionCreator.async<CreateAboTopicRequest, undefined>('CREATE_ABO_TOPIC')

export const deleteAboTopicInitiated = actionCreator<DeleteAboTopicRequest>('DELETE_ABO_TOPIC_INITIATED')
export const deleteAboTopic = actionCreator.async<DeleteAboTopicRequest, undefined>('DELETE_ABO_TOPIC')

export const getTopicsAndMetadataForCurrentUserInitiated = actionCreator('GET_ABO_TOPICS_INITIATED')
export const getTopicsAndMetadataForCurrentUser = actionCreator.async<undefined, TopicsWithMetadataResponse>('GET_ABO_TOPICS')

export const updateAboTopicInitiated = actionCreator<UpdateAboTopicRequest>('UPDATE_ABO_TOPIC_INITIATED')
export const updateAboTopic = actionCreator.async<UpdateAboTopicRequest, undefined>('UPDATE_ABO_TOPIC')

export const getAboSettingsForCurrentUserInitiated = actionCreator('GET_ABO_SETTINGS_INITIATED')
export const getAboSettingsForCurrentUser = actionCreator.async<undefined, UserAboSettings[]>('GET_ABO_SETTINGS')

export const updateAboSettingsForCurrentUserInitiated = actionCreator<UpdateAboSettingsForCurrentUserRequest>('UPDATE_ABO_SETTINGS_INITIATED')
export const updateAboSettingsForCurrentUser = actionCreator.async<UpdateAboSettingsForCurrentUserRequest, undefined>('UPDATE_ABO_SETTINGS')

export const uploadTemporaryMediaFileInitiated = actionCreator<UploadTemporaryMediaFileRequest>('UPLOAD_TEMPORARY_MEDIA_FILE_INITIATED')
export const uploadTemporaryMediaFile = actionCreator.async<UploadTemporaryMediaFileRequest, MediaFileMetadata>('UPLOAD_TEMPORARY_MEDIA_FILE')

export const updateCorePageSettingsInitiated = actionCreator<UpdateCorePageSettingsRequest>('UPDATE_CORE_PAGE_SETTINGS_INITIATED')
export const updateCorePageSettings = actionCreator.async<UpdateCorePageSettingsRequest, undefined>('UPDATE_CORE_PAGE_SETTINGS')

export const getAboTopicHasPostingsInitiated = actionCreator<GetAboTopicHasPostingsRequest>('GET_ABOTOPICS_HAS_POSTINGS_INITIATED')
export const getAboTopicHasPostings = actionCreator.async<GetAboTopicHasPostingsRequest, AboTopicHasPostingsResponse>('GET_ABOTOPICS_HAS_POSTINGS')

export const acknowledgeSettingsForNetworkPageInitiated = actionCreator<AcknowledgeSettingsForNetworkPageRequest>('ACKNOWLEGDE_SETTINGS_FOR_CURRENT_PAGE_INITIATED')
export const acknowledgeSettingsForNetworkPage = actionCreator.async<AcknowledgeSettingsForNetworkPageRequest, undefined>('ACKNOWLEGDE_SETTINGS_FOR_CURRENT_PAGE')

export const getAuditLogForNetworkPageInitiated = actionCreator<GetAuditLogForNetworkPageRequest>('GET_AUDIT_LOG_FOR_CURRENT_PAGE_INITIATED')
export const getAuditLogForNetworkPage = actionCreator.async<GetAuditLogForNetworkPageRequest, AboSettingsAuditLog[]>('GET_AUDIT_LOG_FOR_CURRENT_PAGE')
